import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'purchaseHistory',
    standalone: false
})
export class PurchaseHistoryPipe implements PipeTransform {
    transform(data: any): any {
        return !!(data?.isRevealed ||
            data?.isExportedToCsv ||
            data?.isExportedToSalesforce ||
            data?.isExportedToSalesloft ||
            data?.isExportedToHubspot ||
            data?.isExportedToOutreach ||
            data?.isExportedToMarketo ||
            data?.isExportedToDynamics ||
            data?.isExportedToZoho);
    }
}
